import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../components/shared/Header/Header';

import BrowseTabs from './BrowseTabs/BrowseTabs';

const Browse = ({ tab, isPublic }) => {
  const { t } = useTranslation('browse');

  return (
    <div className="flex-grow-1">
      <Header isPublic={isPublic} title={t('title')} />
      <BrowseTabs tab={tab} isPublic={isPublic} />
    </div>
  );
};

export default Browse;
